import React, { Component } from 'react';
import Header from '../../../Layout/Header'
import { Circle } from '../../TheMoshiDifference/TheMoshiDifference'
class index extends Component {
	render() {
		return (
			<div className="page-case-study">
				<Header
					bg="#1b68a7"
					title={"Business News"}
					image={require('./video.jpg')}
				/>
				<div className="entry-content">
					
					<div className="container-fluid">
						<h2 className="outline text-center">
							<div className="line"></div>
							<div className="title">Looking for an easy to use mobile app</div>
						</h2>
						<div className="row">
							<div className="col-lg-1"></div>
							<div className="col-lg-3">
								<Circle image={require('../../ContactUs/business-news.png')} />
							</div>
							<div className="col-lg-1"></div>
							<div className="col-lg-6">
								<div className="tagline">Moshi Moshi worked with Business News to develop an app for their market that was intuitive and simple to use. The challenge was to develop an app that could access their huge database of news stories while staying as fast as possible.</div>
								<p>Assistance included:</p>
								<ul className="with-icons">
									<li>App design and development <a href="https://www.businessnews.com.au/app" target="_blank">www.businessnews.com.au/app</a></li>
									<li>Marketing consultancy</li>
								</ul>
							</div>
						</div>
					</div>

					<div className="container-fluid example-work">
						<div className="row">
						<div className="col-lg-1"></div>
						<div className="col-lg-6">
							<img src={require('./feature.jpg')} alt="Nites Electrical Feature" width="100%" />
						</div>
							<div className="col-lg-4">
								<img src={require('./example-1.jpg')} alt="Nites Electrical Feature" width="100%" />
								<img src={require('./example-2.jpg')} alt="Nites Electrical Feature" width="100%" />
						</div>
							<div className="col-lg-1"></div>
						</div>
					</div>


					

				</div>


			</div>
		);
	}
}

export default index;


// WEBPACK FOOTER //
// ./src/Pages/WhatWeveDone/BusinessNews/index.js